export default "__VITE_ASSET__be9ca4bd__"